export * from "../../app/ts/models.generated";

export class Cancel {
    static __CANCEL__ = true;

    constructor(public message: string) {}

    public toString(): string {
        return "Cancel" + (this.message ? ": " + this.message : "");
    }
}

export class CancelToken {
    static source(): { token: CancelToken; cancel: any } {
        let cancel;
        const token = new CancelToken((c) => { cancel = c; });

        return {
            token,
            cancel,
        };
    }

    public promise: Promise<Cancel>;
    public reason: Cancel | null = null;

    constructor(executor: (resolve: (value?: any) => void, reject?: (reason?: any) => void) => void) {

        let resolvePromise: any;
        this.promise = new Promise((resolve) => {
            resolvePromise = resolve;
        });

        executor((message) => {
            if (this.reason) {
                return;
            }
            this.reason = new Cancel(message);
            resolvePromise(this.reason);
        });
    }

    public throwIfRequested(): void {
        if (this.reason) {
            throw this.reason;
        }
    }
}
